import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';

function initialize(storiesStaraElement) {
    const swiperPagination = storiesStaraElement.querySelector('.swiper-pagination');
    const progressBar = storiesStaraElement.querySelector('.swiper-pagination');

    new Swiper(storiesStaraElement.querySelector('.swiper'), {
        modules: [Pagination, Navigation, Autoplay],
        slidesPerView: 1,
        loop: true,
        spaceBetween: 20,

        breakpoints: {
            320: {
                spaceBetween: 20,
            },
        },

        autoplay: {
            delay: 15000,
            disableOnInteraction: false,
        },

        navigation: {
            nextEl: storiesStaraElement.querySelector('.btn-next'),
            prevEl: storiesStaraElement.querySelector('.btn-prev'),
        },

        pagination: {
            el: swiperPagination,
            clickable: true,
            renderBullet: function (index, className) {
                return (
                    '<span class="swiper-pagination-bullet">' +
                    ' <span>' +
                    (index + 1).toString().padStart(2, '0') +
                    '</span>' +
                    ' <div class="progress"><span class="progress-bar"></span></div> ' +
                    '</span>'
                );
            },
        },
        on: {
            autoplayTimeLeft(s, time, progress) {
                progressBar.style.setProperty('--progress', 1 - progress);
            },
        },
    });
}

function initializeAll() {
    document.querySelectorAll('.stories-stara').forEach(function (element) {
        initialize(element);
    });
}

initializeAll();
